import { render } from "./HouseFooter.vue?vue&type=template&id=14aebafc"
const script = {}

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__